
export default {
  name: 'List',
  data() {
    return {
      active: null,
    };
  },
  computed: {
    merchantContent() {
      return this.$store.state.route.merchantContent;
    },
    tabs() {
      // {
      //   title: this.$i18n('customer.useful-information', { country: this.airportCountry }),
      //     body: '',
      // },
      const tabs = [];
      if (this.merchantContent?.how_to_park) {
        tabs.push({
          title: `${this.parkingType} ${this.$i18n('general.parking').toLowerCase()}`,
          body: this.merchantContent.how_to_park,
          key: 'parking-content',
        });
      }
      if (this.$store.state.airportRouteContent?.content) {
        tabs.push({
          title: this.$i18n('customer.traffic-information'),
          body: this.$store.state.airportRouteContent.content,
          key: 'traffic-information',
        });
      }
      return tabs;
    },
    airport() {
      return this.$store.state.airport;
    },
    airportCountry() {
      return this.airport.country?.name || '';
    },
    parkingType() {
      if (this.$store.state.route.parkingService?.price_type) {
        return this.$i18n(`reservation.${this.$store.state.route.parkingService?.price_type}`);
      }
      return '-';
    },
  },
  mounted() {
    this.$nuxt.$on('open-instruction', this.openInstruction);
  },
  beforeDestroy() {
    this.$nuxt.$off('open-instruction', this.openInstruction);
  },
  methods: {
    openInstruction({ key = null, forceOpen = false }) {
      this.openItem(key, forceOpen);
    },
    openItem(key, forceOpen = false) {
      const el = document.getElementById(`${key}-body`);
      if (el) {
        if (this.active === key && el.style.height !== 0 && !forceOpen) {
          el.style.height = 0;
          this.active = null;
        } else if (!forceOpen || (forceOpen && this.active !== key)) {
          if (this.active) {
            const activeEl = document.getElementById(`${this.active}-body`);
            if (activeEl) {
              activeEl.style.height = 0;
            }
          }
          this.active = key;
          el.style.height = `${el.getElementsByTagName('div')[0].clientHeight}px`;
        }
      }
    },
  },
};
